export const customerResourceType = 'customer';
